<title>{{ functionalCapabilitiesOfferManagementPage.htmlTitle }}</title>
<div *ngIf="isTab" class="mt-20">
  <ul class="d-flex nav-bar">
    <li *ngFor="let tab of apiTabs; let i = index" class="tab-link bgdgry"
      [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'" (click)="selectedIndex = i">
      <a class="nav-link active" data-bs-toggle="tab" (click)="setPageTitle(apiName + ' ' + tab)">
        <i [ngClass]="apiTabsClass[i]"></i>
        {{ tab }}</a>
    </li>
  </ul>
</div>
<!-- Tab panes -->
<div class="tab-content">
  <app-functional-capabilities-introduction-section
    [sections]="functionalCapabilitiesOfferManagementPage.introductionSections">
  </app-functional-capabilities-introduction-section>
  <app-functional-capabilities-details-xml-section [sections]="functionalCapabilitiesOfferManagementPage.xmlSections">
  </app-functional-capabilities-details-xml-section>
  <app-functional-capabilities-table-section [tableSections]="functionalCapabilitiesOfferManagementPage.tableSections">
  </app-functional-capabilities-table-section>
  <app-functional-capabilities-details-xml-section
    [sections]="functionalCapabilitiesOfferManagementPage.xmlAroundTable">
  </app-functional-capabilities-details-xml-section>
  <app-functional-capabilities-introduction-section
    [sections]="functionalCapabilitiesOfferManagementPage.samplesintroductionSections">
  </app-functional-capabilities-introduction-section>
  <app-functional-capabilities-note-section *ngIf="functionalCapabilitiesOfferManagementPage.noteSections?.length"
    [noteSections]="functionalCapabilitiesOfferManagementPage.noteSections || []">
  </app-functional-capabilities-note-section>
  <app-functional-capabilities-ribbon-tile-section [isRibbonTile]="true"
    [ribbonTileSections]="functionalCapabilitiesOfferManagementPage.ribbonTileSections">
  </app-functional-capabilities-ribbon-tile-section>
</div>